{
  "blocks": [
    {
      "id": "med-tamoxifen",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "iui",
        "ivf",
        "evidence-based"
      ],
      "title": "Tamoxifen",
      "subtitle": "Selective estrogen receptor modulator (SERM) for ovulation induction",
      "body": {
        "genericName": "Tamoxifen citrate",
        "drugClass": "Selective estrogen receptor modulator (SERM)",
        "purpose": "Used as an alternative to clomiphene citrate for ovulation induction, particularly in women who respond poorly to clomid or experience significant side effects. Tamoxifen blocks estrogen receptors in the hypothalamus, triggering increased FSH release and follicle development. Unlike clomid, it has a less anti-estrogenic effect on the endometrium, which may benefit lining thickness.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "20-40 mg daily for 5 days, starting on cycle day 2-5 (similar to clomid protocol)",
        "howToTake": "Step 1: Prepare - Confirm your starting day and dose with your clinic (typically cycle day 2-5, similar to a clomid protocol). Have your tablets ready and set a daily alarm for consistency. | Step 2: Take medication - Take by mouth once or twice daily for 5 days early in your cycle, as directed by your doctor. Can be taken with or without food. | Step 3: After taking - Attend all scheduled ultrasound appointments so your clinic can monitor follicle development and endometrial thickness. Timing of intercourse or IUI will be guided by ultrasound findings and/or LH surge detection. | ⚠ Missed dose - Take the missed dose as soon as you remember the same day. If you don't remember until the next day, skip the missed dose and continue your regular schedule - do not double up. Contact your clinic so they can adjust monitoring if needed. | ⚠ When to call clinic - Call if you experience visual disturbances (blurred vision or spots), severe abdominal pain, significant bloating, or any signs of ovarian hyperstimulation.",
        "sideEffects": [
          "Hot flashes",
          "Nausea",
          "Headache",
          "Fatigue",
          "Mood changes",
          "Less endometrial thinning than clomid",
          "Very rare: visual disturbances"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from light.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Nolvadex", "Soltamox"]
          },
          {
            "country": "UK",
            "brands": ["Nolvadex", "Tamoxifen"]
          },
          {
            "country": "EU",
            "brands": ["Nolvadex", "Tamoxifen"]
          },
          {
            "country": "AU",
            "brands": ["Nolvadex", "Genox"]
          },
          {
            "country": "FR",
            "brands": ["Nolvadex", "Tamoxifène Mylan", "Tamoxifène Sandoz"],
            "cisByBrand": {
              "Nolvadex": "60328432",
              "Tamoxifène Sandoz": "69424909"
            }
          }
        ],
        "availability": [
          {
            "name": "Nolvadex",
            "manufacturer": "AstraZeneca",
            "countries": [
              "US",
              "GB",
              "AU",
              "CA",
              "PH",
              "SG",
              "HK",
              "MY",
              "TH",
              "VN"
            ]
          },
          {
            "name": "Soltamox",
            "manufacturer": "Mayne Pharma",
            "countries": ["US", "GB"]
          },
          {
            "name": "Genox",
            "manufacturer": "Viatris",
            "countries": ["AU"]
          },
          {
            "name": "Tamoxifen Sandoz",
            "manufacturer": "Sandoz",
            "countries": ["AU", "TH"]
          }
        ],
        "aliases": ["Tamoxifène", "Nolvadex", "Tamoxifen citrate"],
        "forWhom": "her",
        "frBody": {
          "genericName": "Citrate de tamoxifène",
          "drugClass": "Modulateur sélectif des récepteurs aux œstrogènes (SERM)",
          "purpose": "Utilisé comme alternative au citrate de clomifène pour l'induction de l'ovulation, en particulier chez les femmes qui répondent mal au clomifène ou présentent des effets indésirables marqués. Le tamoxifène bloque les récepteurs aux œstrogènes au niveau de l'hypothalamus, ce qui augmente la sécrétion de FSH et stimule la croissance folliculaire. Contrairement au clomifène, son effet anti-œstrogénique sur l'endomètre est moindre, ce qui peut être favorable à l'épaisseur de la muqueuse.",
          "dosageRanges": "20 à 40 mg par jour pendant 5 jours, à partir du 2e au 5e jour du cycle (protocole proche de celui du clomifène).",
          "howToTake": "Préparer - Confirmez le jour de début et la dose avec votre centre (généralement au 2e-5e jour du cycle, comme pour un protocole clomifène). Ayez vos comprimés à portée de main et programmez une alarme quotidienne. | Prendre le médicament - Prenez par voie orale une à deux fois par jour pendant 5 jours en début de cycle, selon la prescription. Peut être pris avec ou sans nourriture. | Après la prise - Assistez à toutes les échographies de suivi pour permettre à votre centre de surveiller la croissance folliculaire et l'épaisseur de l'endomètre. Le moment des rapports ou de l'IIU sera guidé par l'échographie et/ou la détection du pic de LH. | ⚠ Dose oubliée - Prenez la dose oubliée dès que vous y pensez le jour même. Si vous ne vous en souvenez que le lendemain, sautez-la et continuez votre rythme habituel - ne doublez jamais la dose. Prévenez votre centre pour qu'il puisse adapter le suivi. | ⚠ Quand contacter le centre - Contactez votre centre en cas de troubles visuels (vision floue ou taches), de douleurs abdominales sévères, de ballonnements importants ou de tout signe d'hyperstimulation ovarienne.",
          "sideEffects": [
            "Bouffées de chaleur",
            "Nausées",
            "Maux de tête",
            "Fatigue",
            "Changements d'humeur",
            "Moins d'amincissement de l'endomètre qu'avec le clomifène",
            "Très rare : troubles visuels"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de la lumière."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
